import { type Destinatario } from '@framework/api-client/api/inquiries-compile/schemas/destinatario.ts';
import { ISODate } from '@framework/ui/components/date/ISODate.tsx';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

export interface ICommunicationReadStateTagProps {
  recipient: Destinatario | null | undefined;
}

/**
 * Tag con lo stato di lettura di un destinatario, con la data di lettura
 * quando disponibile. Non rende nulla senza uno stato di lettura esplicito
 * (`flLetta` assente).
 */
export function CommunicationReadStateTag(
  props: ICommunicationReadStateTagProps,
) {
  const { recipient } = props;
  const { t } = useTranslation();

  if (recipient?.flLetta == null) return null;

  if (!recipient.flLetta) {
    return <Tag>{t('communication-recipient.unread', 'Non letta')}</Tag>;
  }

  return (
    <Tag color="green">
      {t('communication-recipient.read', 'Letta')}
      {recipient.dataLettura && (
        <>
          {' '}
          <ISODate date={recipient.dataLettura} format="DD/MM/YYYY" />
        </>
      )}
    </Tag>
  );
}
